import DisruptionDetails from './DisruptionDetails';

export default DisruptionDetails;
